var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "yxtbiz-ote-type-selector-dropdown",
      class: {
        "yxtbiz-ote-type-selector-dropdown--large": _vm.large,
      },
    },
    [
      _c(
        "yxt-dropdown",
        {
          attrs: { trigger: "click", "custom-elm": "" },
          on: { "visible-change": _vm.change },
        },
        [
          _c(
            "div",
            {
              ref: "refBtn",
              staticClass: "yxtbiz-ote-type-selector-dropdown__btn",
              class: {
                "yxtbiz-ote-type-selector-dropdown__btn--active": _vm.showMenu,
              },
            },
            [
              _c("span", { staticClass: "ellipsis" }, [
                _vm._v(
                  _vm._s(_vm.showTitle ? _vm.title + " " : "") +
                    _vm._s(_vm.name)
                ),
              ]),
              _c("yxt-svg", {
                staticClass: "ml4",
                class: _vm.showMenu ? "trans-270deg" : "trans-90deg",
                attrs: { width: "14px", height: "14px", "icon-class": "right" },
              }),
            ],
            1
          ),
          _c(
            "yxt-dropdown-menu",
            {
              staticClass: "yxtbiz-ote-type-selector-dropdown__dropdown",
              attrs: { slot: "dropdown" },
              slot: "dropdown",
            },
            [
              _c(
                "div",
                {
                  staticClass: "p12",
                  attrs: { slot: "custom" },
                  on: {
                    mousedown: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                  slot: "custom",
                },
                [
                  _c(
                    "div",
                    { staticClass: "yxtbiz-ote-type-selector-dropdown__title" },
                    [_vm._v(_vm._s(_vm.title))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "yxtbiz-ote-type-selector-dropdown__menus",
                      class: {
                        "yxtbiz-ote-type-selector-dropdown__menus--long":
                          _vm.long,
                      },
                    },
                    _vm._l(_vm.menus, function (menu) {
                      return _c(
                        "div",
                        {
                          key: menu.id,
                          staticClass:
                            "yxtbiz-ote-type-selector-dropdown__menu",
                          class: {
                            "yxtbiz-ote-type-selector-dropdown__menu--selected":
                              menu.id === _vm.value,
                            "yxtbiz-ote-type-selector-dropdown__menu--center":
                              _vm.itemCenter,
                          },
                          style: {
                            minWidth: _vm.itemMinWidth,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.select(menu)
                            },
                          },
                        },
                        [
                          menu.icon
                            ? _c("yxt-svg", {
                                staticClass: "mr8",
                                attrs: {
                                  "remote-url": _vm.SvgMediaUrl,
                                  width: "16px",
                                  height: "16px",
                                  "icon-class": menu.icon,
                                },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n            " +
                              _vm._s(menu.name) +
                              "\n          "
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }